import { BIToggleButton, StyledToggleButtonItem } from '@pulsepointinc/bi-components';
import styled from 'styled-components';

export const StyledBIToggleButtons = styled(BIToggleButton)`
  flex: 1;
  width: 100%;
  height: 72px;
  ${StyledToggleButtonItem} {
    height: 36px !important;
  }
`;
